import {
  ContactsOutlined,
  LogoutOutlined,
  MobileTwoTone,
  SecurityScanOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { MenuProps, Space, Spin, Typography } from 'antd';
import { createStyles } from 'antd-style';
import { stringify } from 'querystring';
import React from 'react';
import { flushSync } from 'react-dom';
import HeaderDropdown from '../HeaderDropdown';
import { PassportService } from '@/services/PassportService';
import { LOGIN_PATH } from '@/conf/constants';
import { AvatarViewer } from '@/components/Viewer/FileViewer';
import { useToken } from '@ant-design/pro-components';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  return <span className="anticon">{currentUser?.name}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    await PassportService.logout();
    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect');
    // Note: There may be security issues, please note
    if (window.location.pathname !== LOGIN_PATH && !redirect) {
      history.replace({
        pathname: LOGIN_PATH,
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
  };

  const { styles } = useStyles();
  const { token } = useToken();

  const { initialState, setInitialState } = useModel('@@initialState');

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    // if (key === 'logout') {
    //   flushSync(() => {
    //     setInitialState((s) => ({ ...s, currentUser: undefined }));
    //   });
    //   loginOut();
    //   return;
    // }
    switch (key) {
      case 'logout':
        flushSync(() => {
          setInitialState((s) => ({ ...s, currentUser: undefined }));
        });
        loginOut();
        return;
      case 'base':
        break;
      case 'phone':
        break;
      default:
        history.push(`/profile/${key}`);
        break;
    }
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;
  const settings: any = initialState?.settings ?? {};

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems = [
    ...(menu
      ? [
          {
            key: 'base',
            // icon: <MobileTwoTone />,
            label: (
              <Space>
                <AvatarViewer avatar={currentUser.avatar} size={48} />
                <Space direction={'vertical'} align={'start'}>
                  <Typography.Text>{currentUser.name}</Typography.Text>
                  <Typography.Text type="secondary">ID:{currentUser.id}</Typography.Text>
                </Space>
              </Space>
            ),
            // label: currentUser.phone,
          },
          {
            key: 'phone',
            // icon: <MobileTwoTone />,
            label: (
              <Space>
                <MobileTwoTone />
                <Typography.Text>{currentUser.phone}</Typography.Text>
              </Space>
            ),
          },
          {
            key: 'info',
            icon: <ContactsOutlined />,
            label: '个人信息',
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置',
          },
          {
            key: 'security',
            icon: <SecurityScanOutlined />,
            label: '修改密码',
          },
          {
            type: 'divider' as const,
          },
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      <Space style={{ paddingInline: token.paddingSM }} align="center">
        <AvatarViewer avatar={`${initialState?.currentUser?.avatar}`} size={24} />
        {settings?.layout == 'side' && settings?.collapsed ? '' : <AvatarName />}
      </Space>
    </HeaderDropdown>
  );

  // return (
  //   <HeaderDropdown
  //     menu={{
  //       selectedKeys: [],
  //       onClick: onMenuClick,
  //       items: menuItems,
  //     }}
  //   >
  //     {children}
  //   </HeaderDropdown>
  // );
};
